import { OpenReplaySessionContext } from './types';

export const openReplaySessionContext: OpenReplaySessionContext = {
	metadata: {},
};

export function updateOpenReplaySessionContext(
	userId?: string | null,
	quizId?: string | number | null,
): void {
	if (userId) {
		openReplaySessionContext.userID = String(userId);
	}

	if (quizId !== null && quizId !== undefined && quizId !== '') {
		openReplaySessionContext.metadata.quizId = String(quizId);
	}
}

export function getOpenReplayEventContext(): Record<string, string> {
	return {
		...(openReplaySessionContext.userID ? { userId: openReplaySessionContext.userID } : {}),
		...(openReplaySessionContext.metadata.quizId ? {
			quizId: openReplaySessionContext.metadata.quizId,
		} : {}),
	};
}
